import React, { useState, useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import SectionCard from '../inventory/components/SectionCard';
import { InvSelect } from '../inventory/components/InvField';
import StoreConsumptionForm from '../inventory/components/store/StoreConsumptionForm';
import { getStores } from '../inventory/api/stockLedger';
import { toInventoryList } from '../inventory/api/inventory-request';
import { storeDisplayName } from '../inventory/utils/storeEntity';
import { filterStoresByAssignment } from '../inventory/utils/assignedStores';
import useInvRole from '../inventory/hooks/useInvRole';

import { OT_SECTION_SX } from './otTheme';

export default function PatientConsumptionSection({ patient, formApiRef }) {
  const { myStoreId, myStoreIds } = useInvRole();
  const [stores, setStores] = useState([]);
  const [storeId, setStoreId] = useState('');

  useEffect(() => {
    getStores()
      .then(d => setStores(toInventoryList(d)))
      .catch(() => setStores([]));
  }, []);

  useEffect(() => {
    if (!storeId && myStoreId && stores.some(s => (s.store_id || s.id) === myStoreId)) {
      setStoreId(myStoreId);
    }
  }, [myStoreId, stores, storeId]);

  // Assigned stores only; unscoped users keep the full list.
  const storeOptions = useMemo(
    () => filterStoresByAssignment(stores, myStoreIds)
      .map(s => ({ value: s.store_id || s.id, label: storeDisplayName(s) })),
    [stores, myStoreIds],
  );

  const storeName = storeOptions.find(s => s.value === storeId)?.label || '';

  return (
    <SectionCard title="Patient Consumption" sx={OT_SECTION_SX}>
      <Box sx={{ mb: 2.5, maxWidth: 420 }}>
        <InvSelect
          label="Store *"
          value={storeId}
          onChange={e => setStoreId(e.target.value)}
          options={storeOptions}
        />
      </Box>
      <StoreConsumptionForm
        storeId={storeId}
        storeName={storeName}
        consumptionType="PATIENT"
        patient={patient || null}
        hideSubmit
        formApiRef={formApiRef}
      />
    </SectionCard>
  );
}
